/* GENERATED by tools/build-shopify.py from ca89-map.html. Do not edit. */
function ca89MapInit() {
  'use strict';

  // Image paths. Locally they sit next to this file; on Shopify the section
  // sets window.CA89_ASSETS to the theme's asset URLs.
  var ASSETS = Object.assign({
    shieldMustard: 'California-89_Shield-Logo_Mustard.png',
    shieldGrey:    'California-89_Shield-Logo_Grey.png'
  }, window.CA89_ASSETS || {});

  /* ============================================================
     TYPE CONFIG
  ============================================================ */
  var TYPE_CONFIG = {
    store:    { color: '#1D9E75', label: 'CA89 Store'          },
    iconic:   { color: '#E8E0D0', label: 'Iconic Destination'  },
    favorite: { color: '#C9973A', label: 'Favorite'            },
    card:     { color: '#7FA86B', label: 'Trail Card'          }
  };

  /* ============================================================
     DIFFICULTY COLOURS
     Matches the colour band printed on the card front, so a customer holding
     a green card sees green pins on the wall. Keep these in sync with the
     print files — replace with the exact press hex when you have it.
  ============================================================ */
  // ONE TABLE PER DECK. The decks do not share a palette: Hike prints
  // green / blue / red; Bike prints Square One's "Palette B" (sage = Easy,
  // blue = Moderate, Hard not yet confirmed). All values below are
  // PLACEHOLDERS until Square One sends the press values (asked 2026-10-23).
  // Bike repeats the Hike placeholders rather than guessing at its colours.
  // When the real values land, this table is the only place to change.
  var DIFFICULTY_COLORS = {
    hike: { easy: '#636F4D', moderate: '#A3BAD0', hard: '#DC5039' },
    bike: { easy: '#B7C194', moderate: '#1F7D93', hard: '#C86428' }
  };

  function difficultyColor(d, deck) {
    var pal = DIFFICULTY_COLORS[deck] || DIFFICULTY_COLORS.hike;
    return pal[String(d || '').toLowerCase()] || '#E8E0D0';
  }

  /* ============================================================
     LOCATIONS — derived from data/ca89-places.js
     That file is the single source of truth: the same records drive the
     printed rack cards and the digital guides. Edit places there, not here.
  ============================================================ */
  if (!window.CA89_PLACES) {
    console.error('CA89: data/ca89-places.js did not load — no pins to draw.');
  }

  var PLACES = window.CA89_PLACES || [];

  // The map draws three visual treatments; a place's record decides which.
  function mapType(place) {
    if (place.kind === 'store') return 'store';
    if (place.pick)             return 'favorite';
    return 'iconic';
  }

  // Printed cards carry their own GPS coordinates, so they place themselves.
  // Anything without coordinates is skipped rather than guessed at.
  var CARDS = (window.CA89_CARDS || []).filter(function (c) {
    return typeof c.lat === 'number' && typeof c.lon === 'number';
  });

  /* Home view: Truckee and Tahoe, where 54 of the 60 trails and all three
     stores are. The whole highway is one button away ("All of Highway 89"). */
  var HOME_BOUNDS = L.latLngBounds(CARDS.map(function (c) { return [c.lat, c.lon]; }));
  (window.CA89_PLACES || []).forEach(function (p) {
    if (p.kind === 'store') HOME_BOUNDS.extend([p.lat, p.lon]);
  });
  var STORE_BOUNDS = null;
  (window.CA89_PLACES || []).forEach(function (p) {
    if (p.kind !== 'store') return;
    STORE_BOUNDS = STORE_BOUNDS ? STORE_BOUNDS.extend([p.lat, p.lon]) : L.latLngBounds([p.lat, p.lon], [p.lat, p.lon]);
  });

  // Landmarks tab frames the Tahoe-area stops (most of the poster's places);
  // Shasta, Burney, Lassen and Graeagle stay in the list, a tap away.
  var LANDMARK_BOUNDS = null;
  (window.CA89_PLACES || []).forEach(function (p) {
    if (!p.iconic || p.lat > 39.5) return;
    LANDMARK_BOUNDS = LANDMARK_BOUNDS ? LANDMARK_BOUNDS.extend([p.lat, p.lon]) : L.latLngBounds([p.lat, p.lon], [p.lat, p.lon]);
  });

  // The tab shown first. "The Road" is the simple first look.
  var activeTab = 'road';

  // Room taken by the tabs and the list panel, measured live, so framing,
  // popups and region labels all stay clear of them in every layout.
  function obstacles() {
    var box = map.getContainer().getBoundingClientRect();
    var o = { left: box.left + 8, right: box.right - 8, top: box.top + 8, bottom: box.bottom - 8, box: box };
    var wrap = document.querySelector('.ca89-map-wrap');
    var t = document.getElementById('ca89-tabs'), p = document.getElementById('ca89-panel');
    if (!wrap || !t || !p) return o;
    var layout = wrap.getAttribute('data-tabs');
    var tr = t.getBoundingClientRect(), pr = p.getBoundingClientRect();
    if (window.matchMedia('(max-width: 768px)').matches) {
      o.bottom = Math.min(o.bottom, pr.top - 8, tr.top - 8);
    } else {
      o.left = Math.max(o.left, pr.right + 8);
      if (layout === 'left')   o.left   = Math.max(o.left, tr.right + 8);
      if (layout === 'top')    o.top    = Math.max(o.top, tr.bottom + 8);
      if (layout === 'bottom') o.bottom = Math.min(o.bottom, tr.top - 8);
    }
    return o;
  }
  function framePadding() {
    var o = obstacles(), b = o.box;
    return { paddingTopLeft:     [o.left - b.left + 16, o.top - b.top + 16],
             paddingBottomRight: [b.right - o.right + 16, b.bottom - o.bottom + 16] };
  }
  function homePadding() { return framePadding(); }

  /* Published long-form guides (california89.com/blogs/hike|bike/...),
     matched to their printed card by deck + name. Names are normalised
     because the blog and the card differ in small ways: a curly apostrophe
     ("Maggie\u2019s"), or a trailing "Trail" ("Carpenter Valley Trail"). */
  function guideKey(deck, name) {
    return deck + '/' + String(name || '').toLowerCase()
      .replace(/[\u2018\u2019']/g, '')
      .replace(/&/g, 'and')
      .replace(/\btrail\s*$/, '')
      .replace(/[^a-z0-9]+/g, '');
  }
  var GUIDE_URLS = {};
  var GUIDE_SRC = window.CA89_GUIDE_PLACES || {};
  Object.keys(GUIDE_SRC).forEach(function (deck) {
    (GUIDE_SRC[deck] || []).forEach(function (g) {
      if (g.guideUrl) GUIDE_URLS[guideKey(deck, g.name)] = g.guideUrl;
    });
  });
  // Relative on california89.com; absolute everywhere else (local preview).
  var SITE_ORIGIN = /(^|\.)california89\.com$/.test(location.hostname)
    ? '' : 'https://www.california89.com';
  function guideUrlFor(c) {
    var u = GUIDE_URLS[guideKey(c.deck, c.name)];
    return u ? SITE_ORIGIN + u : null;
  }

  var CARD_LOCATIONS = CARDS.map(function (c) {
    return {
      id:          c.id,
      name:        c.name,
      lat:         c.lat,
      lon:         c.lon,
      type:        'card',
      deck:        c.deck,
      icon:        c.deck === 'bike' ? 'star' : 'hiker',
      color:       difficultyColor(c.difficulty, c.deck),
      desc:        c.description,
      collections: [c.deck],
      card: c,
      notes: {
        distance: c.distance,
        gain:     c.elevationGain,
        time:     c.time,
        level:    c.difficulty
      },
      card: c
    };
  });

  var LOCATIONS = PLACES.map(function (p) {
    return {
      id:            p.id,
      name:          p.name,
      lat:           p.lat,
      lon:           p.lon,
      type:          mapType(p),
      icon:          p.icon,
      leader:        p.leader,
      desc:          p.blurb,
      fact:          p.fact || null,
      waypoint:      !!p.waypoint,
      notes:         p.notes || {},
      guideUrl:      p.guideUrl || null,
      collections:   p.collections || [],
      directionsUrl: (p.links && p.links.directions) || null,
      shopUrl:       (p.links && p.links.shop) || null
    };
  }).concat(CARD_LOCATIONS);

  /* ============================================================
     NEUTRALIZE DEFAULT LEAFLET ICON
  ============================================================ */
  delete L.Icon.Default.prototype._getIconUrl;
  L.Icon.Default.mergeOptions({
    iconUrl:       'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
    iconRetinaUrl: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
    shadowUrl:     ''
  });

  /* ============================================================
     MAP INIT
  ============================================================ */
  var map = window.ca89map = L.map('ca89-map', {
    center:          [39.8, -120.8],
    zoom:            7,
    scrollWheelZoom: false,
    zoomControl:     false,
    attributionControl: true
  });

  L.control.zoom({ position: 'topright' }).addTo(map);

  /* Scroll zoom on click; disable on mouse leave */
  map.on('click', function () { map.scrollWheelZoom.enable(); });
  document.getElementById('ca89-map').addEventListener('mouseleave', function () {
    map.scrollWheelZoom.disable();
  });

  /* Dismiss hint on first map click */
  var zoomHint = document.getElementById('ca89-zoom-hint');
  map.once('click', function () {
    zoomHint.style.opacity = '0';
    setTimeout(function () {
      if (zoomHint && zoomHint.parentNode) zoomHint.parentNode.removeChild(zoomHint);
    }, 450);
  });

  /* ============================================================
     TOUCH — one finger scrolls the page, two fingers move the map
     On a phone the map fills most of the screen, and Leaflet's one-finger
     drag trapped the page scroll on it. With dragging off, the container
     falls back to touch-action: pan-x pan-y, so the page scrolls, and
     Leaflet's pinch handler still pans and zooms under two fingers (the
     way embedded Google Maps behave). Not on the kiosk: there the map is
     the whole screen and one finger should move it.
  ============================================================ */
  var IS_KIOSK = /[?&]tier=kiosk/.test(location.search) || window.CA89_TIER === 'kiosk';
  var TOUCH = !IS_KIOSK && window.matchMedia('(pointer: coarse)').matches;
  if (TOUCH) {
    map.dragging.disable();
    if (zoomHint && zoomHint.parentNode) zoomHint.parentNode.removeChild(zoomHint);  // mouse-wheel hint

    var gestureHint = document.getElementById('ca89-gesture-hint'), gestureTimer = null;
    var mapEl = map.getContainer();
    mapEl.addEventListener('touchmove', function (e) {
      // Scrolling a card or the filter pills is not an attempt to move the map.
      if (e.touches.length !== 1 || !gestureHint) return;
      if (e.target.closest && e.target.closest('.leaflet-popup, .leaflet-control')) return;
      gestureHint.classList.add('is-on');
      clearTimeout(gestureTimer);
      gestureTimer = setTimeout(function () { gestureHint.classList.remove('is-on'); }, 1200);
    }, { passive: true });
    mapEl.addEventListener('touchstart', function (e) {
      if (e.touches.length > 1 && gestureHint) gestureHint.classList.remove('is-on');
    }, { passive: true });
  }

  /* ============================================================
     BASEMAPS — terrain relief under a dark brand layer
  ============================================================ */
  map.createPane('hillshade');
  map.getPane('hillshade').style.zIndex = '250';
  map.getPane('hillshade').classList.add('ca89-hillshade-pane');

  /* FREE SOURCES ONLY (2026-10-23). Keyless Esri is not licensed for a
     commercial site, so the whole stack moved:
       land, water, roads, names  Protomaps vector tiles, cut to the
                                  Highway 89 corridor (tiles/hwy89.pmtiles),
                                  drawn by MapLibre inside Leaflet. OSM data.
       relief, topo, satellite    USGS National Map, US public domain.
     Two looks from the same data, chosen with ?theme=light|dark. */
  // Light is the chosen look (Ethan, 2026-10-23). Dark stays available.
  var THEME = (location.search.match(/[?&]theme=(light|dark)/) || [])[1] ||
              window.CA89_THEME || 'light';
  (document.getElementById('ca89-road') || document.documentElement)
    .classList.add('ca89-theme-' + THEME);

  // Local preview: `pmtiles serve tiles --port 8090`. Production: set
  // window.CA89_TILES to the hosted URL before this script runs.
  // Local only: ?tiles=<archive name> picks another archive from tiles/.
  var LOCAL_TILES = /^(localhost|127\.0\.0\.1)$/.test(location.hostname) &&
                    (location.search.match(/[?&]tiles=([\w-]+)/) || [])[1];
  // Local only: ?pmtiles=<archive name> reads the single file over HTTP range
  // requests, exactly as production does (tools/serve-range.py on 8091).
  var LOCAL_FILE = /^(localhost|127\.0\.0\.1)$/.test(location.hostname) &&
                   (location.search.match(/[?&]pmtiles=([\w-]+)/) || [])[1];
  var VECTOR_TILES = window.CA89_TILES ||
    (LOCAL_FILE ? 'http://localhost:8091/' + LOCAL_FILE + '.pmtiles'
                : 'http://localhost:8090/' + (LOCAL_TILES || 'hwy89') + '/{z}/{x}/{y}.mvt');

  // A path like /cdn/shop/files/... is the store's own domain. Shopify Files
  // must be read that way: cdn.shopify.com stopped honouring Range requests
  // once the file was cached (answered 200 with the whole 17 MB), which
  // breaks the reader; the shop-domain path answers 206 every time (tested
  // 2026-10-23). Same origin also means no CORS at all.
  if (/^\/[^\/]/.test(VECTOR_TILES)) VECTOR_TILES = location.origin + VECTOR_TILES;

  // A single .pmtiles file (production: Shopify Files) is read with range
  // requests through the pmtiles protocol. A {z}/{x}/{y} URL is a tile server.
  var IS_PMTILES_FILE = /\.pmtiles(\?|$)/.test(VECTOR_TILES);
  if (IS_PMTILES_FILE && !window.__ca89PmtilesProtocol) {
    maplibregl.addProtocol('pmtiles', new pmtiles.Protocol().tile);
    window.__ca89PmtilesProtocol = true;
  }
  // Highest zoom baked into the archive; MapLibre overzooms past it.
  var TILE_MAXZOOM = window.CA89_TILE_MAXZOOM || (/z13/.test(VECTOR_TILES) ? 13 : 14);
  var PM_ASSETS = 'https://protomaps.github.io/basemaps-assets/';
  var USGS = 'https://basemap.nationalmap.gov/arcgis/rest/services/';
  var OSM_ATTR  = '<a href="https://protomaps.com">Protomaps</a> &copy; ' +
                  '<a href="https://openstreetmap.org/copyright">OpenStreetMap</a>';
  var USGS_ATTR = 'Relief, topo &amp; imagery: USGS The National Map';

  // CA89 trail-map palette: cream paper, sage forest, the brand's light blue
  // for water (Pantone 5493 C family), warm tan road casings.
  var FLAVOR_LIGHT = Object.assign({}, basemaps.namedFlavor('light'), {
    background: '#F2ECDF', earth: '#F2ECDF',
    park_a: '#E2E5D3', park_b: '#CFD8C0', wood_a: '#E0E4D1', wood_b: '#C9D3BC',
    scrub_a: '#E6E6D6', scrub_b: '#D3D9C4', glacier: '#F7F5F0',
    sand: '#ECE3CC', beach: '#ECE3CC', water: '#A9C4CC',
    pedestrian: '#EEE6D6', industrial: '#E8E2D6', school: '#EDE5D7', hospital: '#EEE3DD',
    aerodrome: '#E8E2D6', military: '#E6E0D4', zoo: '#E0E4D1', buildings: '#E2D9C8',
    highway: '#FFFFFF', highway_casing_early: '#D9CBB0', highway_casing_late: '#D9CBB0',
    major: '#FFFDF8', major_casing_early: '#DFD3BC', major_casing_late: '#DFD3BC',
    minor_a: '#F8F3EA', minor_b: '#FFFDF8', minor_casing: '#E6DBC6',
    minor_service: '#F6F0E4', minor_service_casing: '#E6DBC6', other: '#F4EEE3',
    link: '#FFFDF8', link_casing: '#DFD3BC', railway: '#B8AC97', boundaries: '#C9BBA2',
    city_label: '#4A4338', city_label_halo: '#F2ECDF',
    subplace_label: '#857A69', subplace_label_halo: '#F2ECDF',
    state_label: '#B4A78F', state_label_halo: '#F2ECDF',
    roads_label_major: '#8A7F6E', roads_label_major_halo: '#FFFDF8',
    roads_label_minor: '#958A79', roads_label_minor_halo: '#FFFDF8',
    ocean_label: '#6E8F99'
  });

  // Dark: Protomaps' dark flavor, warmed slightly toward the brand.
  var FLAVOR_DARK = Object.assign({}, basemaps.namedFlavor('dark'), {
    background: '#1B1A18', earth: '#1F1E1B', water: '#141B1F',
    park_a: '#212420', park_b: '#232822', wood_a: '#212420', wood_b: '#242923'
  });

  var FLAVOR = THEME === 'light' ? FLAVOR_LIGHT : FLAVOR_DARK;

  function vectorStyle(flavor, sprite, labelsOnly) {
    return {
      version: 8,
      glyphs: PM_ASSETS + 'fonts/{fontstack}/{range}.pbf',
      sprite: PM_ASSETS + 'sprites/v4/' + sprite,
      sources: { protomaps: IS_PMTILES_FILE
        ? { type: 'vector', url: 'pmtiles://' + VECTOR_TILES, attribution: OSM_ATTR }
        : { type: 'vector', tiles: [VECTOR_TILES], maxzoom: TILE_MAXZOOM,
            attribution: OSM_ATTR } },
      layers: labelsOnly
        ? basemaps.layers('protomaps', flavor, { lang: 'en', labelsOnly: true })
        : basemaps.layers('protomaps', flavor)
    };
  }

  var BASEMAPS = {
    terrain: {
      label: 'Terrain',
      make: function () {
        return L.maplibreGL({ style: vectorStyle(FLAVOR, THEME, false), interactive: false });
      },
      relief: true,
      labels: THEME
    },
    topo: {
      label: 'Topo',
      url:   USGS + 'USGSTopo/MapServer/tile/{z}/{y}/{x}',
      opts:  { maxZoom: 18, maxNativeZoom: 16, attribution: USGS_ATTR },
      relief: false,
      labels: null
    },
    satellite: {
      label: 'Satellite',
      url:   USGS + 'USGSImageryOnly/MapServer/tile/{z}/{y}/{x}',
      opts:  { maxZoom: 18, maxNativeZoom: 16, attribution: USGS_ATTR },
      relief: false,
      labels: 'dark'
    }
  };

  var reliefLayer = L.tileLayer(
    USGS + 'USGSShadedReliefOnly/MapServer/tile/{z}/{y}/{x}',
    { pane: 'hillshade', maxZoom: 18, maxNativeZoom: 16, attribution: USGS_ATTR }
  );

  // Place names ride above the relief so terrain never buries them.
  map.createPane('labels');
  map.getPane('labels').style.zIndex = '350';
  map.getPane('labels').style.pointerEvents = 'none';
  map.getPane('labels').classList.add('ca89-labels-pane');

  // Labels-only vector layers, built on first use. Satellite always takes the
  // dark set: light text on a dark halo reads over imagery.
  var LABEL_LAYERS = {};
  function labelLayer(key) {
    if (!LABEL_LAYERS[key]) {
      LABEL_LAYERS[key] = L.maplibreGL({
        style: vectorStyle(key === 'light' ? FLAVOR_LIGHT : FLAVOR_DARK, key, true),
        pane: 'labels', interactive: false
      });
    }
    return LABEL_LAYERS[key];
  }

  var currentBase = null;

  /* Tiles are the only thing this page fetches. If none of them arrive, the
     map is a black rectangle and the reason is invisible — most often a
     preview pane with networking disabled, occasionally just no connection. */
  var tilesLoaded = 0, tileErrors = 0, noticeTimer = null;

  function watchTiles(layer) {
    if (layer.getMaplibreMap) {
      // Vector layer: count it loaded when MapLibre first finishes drawing.
      layer.once('add', function () {
        var gl = layer.getMaplibreMap();
        if (gl) gl.once('idle', function () { tilesLoaded++; hideNotice(); });
      });
      return;
    }
    layer.on('tileload',  function () { tilesLoaded++; hideNotice(); });
    layer.on('tileerror', function () { tileErrors++; });
  }

  function hideNotice() {
    var el = document.getElementById('ca89-offline-notice');
    if (el) el.classList.remove('is-visible');
    if (noticeTimer) { clearTimeout(noticeTimer); noticeTimer = null; }
  }

  function armNotice() {
    if (noticeTimer) clearTimeout(noticeTimer);
    noticeTimer = setTimeout(function () {
      if (tilesLoaded === 0) {
        var el = document.getElementById('ca89-offline-notice');
        if (el) el.classList.add('is-visible');
      }
    }, 6000);
  }

  var wantsRelief = false;

  // Below z7 the relief adds nothing at national scale and source-DEM seams in
  // Esri's hillshade start to show, so it only rides along over the Sierra.
  var RELIEF_MIN_ZOOM = 7;

  function syncRelief() {
    var z  = map.getZoom();
    var on = wantsRelief && z >= RELIEF_MIN_ZOOM;

    if (on && !map.hasLayer(reliefLayer)) { reliefLayer.addTo(map); }
    else if (!on && map.hasLayer(reliefLayer)) { map.removeLayer(reliefLayer); }

    // Source-DEM seams in Esri's hillshade are most visible when zoomed out, so
    // the relief fades in as you come down into the Sierra.
    var pane = map.getPane('hillshade');
    if (pane) {
      pane.style.opacity = z >= 9 ? '0.6' : (z >= 8 ? '0.45' : '0.28');
    }
  }
  map.on('zoomend', syncRelief);

  function setBasemap(key) {
    var cfg = BASEMAPS[key];
    if (!cfg) return;
    if (currentBase) map.removeLayer(currentBase);
    currentBase = cfg.make ? cfg.make() : L.tileLayer(cfg.url, cfg.opts);
    watchTiles(currentBase);
    currentBase.addTo(map);
    if (currentBase.setZIndex) currentBase.setZIndex(1);
    armNotice();

    wantsRelief = cfg.relief;
    syncRelief();

    if (cfg.labels) labelLayer(cfg.labels);
    Object.keys(LABEL_LAYERS).forEach(function (k) {
      var lyr = LABEL_LAYERS[k];
      if (cfg.labels === k) { if (!map.hasLayer(lyr)) lyr.addTo(map); }
      else if (map.hasLayer(lyr)) { map.removeLayer(lyr); }
    });

    document.querySelectorAll('.basemap-btn').forEach(function (b) {
      b.classList.toggle('active', b.getAttribute('data-base') === key);
    });
  }

  /* ============================================================
     HIGHWAY 89 ROUTE — baked static geometry, no runtime API
  ============================================================ */
  var routeLayer = L.layerGroup().addTo(map);
  var routeBounds = null;

  (function drawRoute() {
    var data = window.CA89_ROUTE;
    var statusEl = document.getElementById('ca89-route-loading');

    if (!data || !data.length) {
      if (statusEl) {
        statusEl.textContent = 'Route data missing';
        statusEl.classList.add('is-error');
      }
      return;
    }

    var all = [];
    data.forEach(function (line) {
      // GeoJSON order is [lon, lat] \u2014 Leaflet wants [lat, lon]
      var latlngs = line.map(function (c) { return [c[1], c[0]]; });
      all = all.concat(latlngs);

      // Dark casing underneath makes the highway read as a drawn road,
      // not a stray vector line.
      L.polyline(latlngs, {
        color: THEME === 'light' ? '#FFFDF8' : '#000000', weight: 7,
        opacity: THEME === 'light' ? 0.95 : 0.55,
        lineJoin: 'round', lineCap: 'round', interactive: false
      }).addTo(routeLayer);

      L.polyline(latlngs, {
        color: '#e8821a', weight: 3.5, opacity: 1,
        lineJoin: 'round', lineCap: 'round'
      }).addTo(routeLayer)
        .bindTooltip('Highway 89', { sticky: true, className: 'ca89-tooltip' });
    });

    routeBounds = L.latLngBounds(all);

    if (statusEl) {
      statusEl.textContent = 'Highway 89 \u00b7 Mt. Shasta to Monitor Pass';
      statusEl.classList.add('is-success');
    }
  })();

  setBasemap('terrain');

  /* ------------------------------------------------------------------
     Frame the whole highway on load rather than a hardcoded center/zoom.

     This has to wait for the container to have a real height. Leaflet's
     getBoundsZoom() returns maxZoom when the container measures 0px, so
     fitting too early lands the map at zoom 16 over a random point — and
     invalidateSize() afterwards fixes the size but never re-fits. A section
     that starts hidden (Shopify tabs, accordions, lazy sections) hits this
     every time, so watch the element instead of guessing with a timeout.
  ------------------------------------------------------------------ */
  var framed = false;
  function frameRoute() {
    if (framed || !routeBounds) return;
    map.invalidateSize();
    var sz = map.getSize();
    if (sz.x < 40 || sz.y < 40) return;    // still not laid out
    // animate:false matters — an animated setView is driven by
    // requestAnimationFrame, which does not run while the tab or section is
    // hidden, so the initial fit would silently never complete and the map
    // would sit at its fallback center/zoom. The opening view should just be
    // framed, not fly there.
    frameTab(false);
    framed = true;
    if (ro) ro.disconnect();
  }

  var ro = null;
  if (typeof ResizeObserver !== 'undefined') {
    ro = new ResizeObserver(frameRoute);
    ro.observe(document.getElementById('ca89-map'));
  }
  frameRoute();
  window.addEventListener('load', frameRoute);

  // Force Leaflet to recalculate tile dimensions after layout settles
  setTimeout(function () { map.invalidateSize(); }, 100);
  setTimeout(function () { map.invalidateSize(); }, 250);

  /* ============================================================
     ICON FACTORY — circle pins with custom SVG icons
  ============================================================ */
  var ICON_PATHS = {
    mountain: '<polyline points="2,12 7,2 12,12" stroke="COLOR" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/><polyline points="4,12 7,6 10,12" stroke="COLOR" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>',
    waterfall:'<path d="M4,2 C4,5 3,7 4,10 C5,12 5,12 5,12 M7,2 C7,6 6,8 7,11 M10,2 C10,5 11,7 10,10" stroke="COLOR" stroke-width="1.2" stroke-linecap="round" fill="none"/>',
    pine:     '<polyline points="7,1 2,8 5,8 5,13 9,13 9,8 12,8 7,1" stroke="COLOR" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>',
    wagon:    '<circle cx="7" cy="7" r="5" stroke="COLOR" stroke-width="1.2" fill="none"/><line x1="7" y1="2" x2="7" y2="12" stroke="COLOR" stroke-width="1.2"/><line x1="2" y1="7" x2="12" y2="7" stroke="COLOR" stroke-width="1.2"/><line x1="3.5" y1="3.5" x2="10.5" y2="10.5" stroke="COLOR" stroke-width="1.2"/><line x1="10.5" y1="3.5" x2="3.5" y2="10.5" stroke="COLOR" stroke-width="1.2"/>',
    lift:     '<circle cx="7" cy="3" r="1.5" stroke="COLOR" stroke-width="1.2" fill="none"/><line x1="7" y1="4.5" x2="5" y2="9" stroke="COLOR" stroke-width="1.2" stroke-linecap="round"/><line x1="5" y1="9" x2="3" y2="11" stroke="COLOR" stroke-width="1.2" stroke-linecap="round"/><line x1="5" y1="9" x2="7" y2="11" stroke="COLOR" stroke-width="1.2" stroke-linecap="round"/>',
    wave:     '<path d="M1,6 C2.5,4 4.5,4 6,6 C7.5,8 9.5,8 11,6 C12.5,4 13,5 13,5 M1,9 C2.5,7 4.5,7 6,9 C7.5,11 9.5,11 11,9" stroke="COLOR" stroke-width="1.2" stroke-linecap="round" fill="none"/>',
    hiker:    '<circle cx="7" cy="2.5" r="1.5" stroke="COLOR" stroke-width="1.2" fill="none"/><line x1="7" y1="4" x2="7" y2="9" stroke="COLOR" stroke-width="1.2" stroke-linecap="round"/><line x1="7" y1="6" x2="4" y2="8" stroke="COLOR" stroke-width="1.2" stroke-linecap="round"/><line x1="7" y1="9" x2="5" y2="13" stroke="COLOR" stroke-width="1.2" stroke-linecap="round"/><line x1="7" y1="9" x2="9" y2="13" stroke="COLOR" stroke-width="1.2" stroke-linecap="round"/>',
    sailboat: '<path d="M7,2 L7,10 M7,2 L13,10 M3,10 L13,10 M3,12 Q8,11 13,12" stroke="COLOR" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>',
    train:    '<rect x="2" y="3" width="10" height="7" rx="2" stroke="COLOR" stroke-width="1.2" fill="none"/><line x1="2" y1="7" x2="12" y2="7" stroke="COLOR" stroke-width="1.2"/><circle cx="4" cy="11" r="1.2" stroke="COLOR" stroke-width="1.2" fill="none"/><circle cx="10" cy="11" r="1.2" stroke="COLOR" stroke-width="1.2" fill="none"/><line x1="5" y1="3" x2="5" y2="1" stroke="COLOR" stroke-width="1.2" stroke-linecap="round"/><line x1="9" y1="3" x2="9" y2="1" stroke="COLOR" stroke-width="1.2" stroke-linecap="round"/>',
    star:     '<path d="M7,2 L8.5,5.5 L12,6 L9.5,8.5 L10,12 L7,10.5 L4,12 L4.5,8.5 L2,6 L5.5,5.5 Z" stroke="COLOR" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>'
  };

  function makeCircleIcon(svgContent, color) {
    return L.divIcon({
      className: '',
      html: '<div style="width:28px;height:28px;background:rgba(15,15,15,0.92);border:1.5px solid ' + color + ';border-radius:50%;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,0.6);transition:transform 0.18s cubic-bezier(0.34,1.56,0.64,1)">' +
              '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">' + svgContent + '</svg>' +
            '</div>',
      iconSize:    [28, 28],
      iconAnchor:  [14, 14],
      popupAnchor: [0, -16]
    });
  }

  function getIconSVG(iconKey, color) {
    var tpl = ICON_PATHS[iconKey] || ICON_PATHS.star;
    return tpl.split('COLOR').join(color);
  }

  function createIcon(loc) {
    var type = loc.type;
    var cfg  = TYPE_CONFIG[type];

    if (type === 'store') {
      return L.divIcon({
        className:   '',
        html:        '<img src="' + ASSETS.shieldMustard + '" ' +
                     'style="width:28px;height:auto;display:block;' +
                     'filter:drop-shadow(0 2px 6px rgba(0,0,0,0.9));' +
                     'transition:transform 0.18s cubic-bezier(0.34,1.56,0.64,1)">',
        iconSize:    [28, 32],
        iconAnchor:  [14, 32],
        popupAnchor: [0, -34]
      });
    }

    var iconKey = (type === 'favorite') ? 'star' : (loc.icon || 'mountain');
    var color   = loc.color || cfg.color;
    return makeCircleIcon(getIconSVG(iconKey, color), color);
  }

  /* ============================================================
     LEADER-LINE ICON — logo PNG + angled line + label (store cluster)
     dir: 'upleft' | 'downleft' | 'downright'
  ============================================================ */
  function createLeaderIcon(type, labelText, dir) {
    var w = 28, h = 32;  // store logo dimensions only

    var lx, ly, textAnchor, tx, ty;
    if (dir === 'upleft') {
      lx = -26; ly = -22; textAnchor = 'end';   tx = lx - 4; ty = ly + 4;
    } else if (dir === 'downleft') {
      lx = -26; ly = 14;  textAnchor = 'end';   tx = lx - 4; ty = ly + 4;
    } else {
      lx =  26; ly = 14;  textAnchor = 'start'; tx = lx + 4; ty = ly + 4;
    }

    var ox = w / 2, oy = h;
    var pinGraphic = '<image href="' + ASSETS.shieldMustard + '" x="0" y="0" width="' + w + '" height="' + h + '" ' +
                     'preserveAspectRatio="xMidYMid meet" style="filter:drop-shadow(0 2px 6px rgba(0,0,0,0.9))"/>';

    var html =
      '<svg width="' + w + '" height="' + h + '" ' +
           'viewBox="0 0 ' + w + ' ' + h + '" style="overflow:visible;display:block">' +
        pinGraphic +
        '<line x1="' + ox + '" y1="' + oy + '" x2="' + (ox+lx) + '" y2="' + (oy+ly) + '" ' +
              'stroke="' + (THEME === 'light' ? 'rgba(43,38,32,0.55)' : 'rgba(255,255,255,0.5)') + '" stroke-width="1"/>' +
        '<text x="' + (ox+tx) + '" y="' + (oy+ty) + '" text-anchor="' + textAnchor + '" ' +
              'font-size="10" font-weight="700" ' +
              'font-family="-apple-system,BlinkMacSystemFont,Helvetica,Arial,sans-serif" ' +
              'stroke="' + (THEME === 'light' ? '#F2ECDF' : '#0d0d0d') + '" stroke-width="3" stroke-linejoin="round" ' +
              'paint-order="stroke fill" fill="' + (THEME === 'light' ? '#2B2620' : '#ffffff') + '">' + labelText + '</text>' +
      '</svg>';

    return L.divIcon({
      className:   'ca89-pin',
      html:        html,
      iconSize:    [w, h],
      iconAnchor:  [w / 2, h],
      popupAnchor: [0, -h - 2]
    });
  }

  /* ============================================================
     POPUP BUILDER
  ============================================================ */
  /* ============================================================
     CONTENT TIER — how much of a printed card the screen gives away
     ============================================================

     The decks are a $30 product. The map's job is to make someone want one,
     not to replace it, so the fields that make a card worth buying stay on
     the card.

       public  web map. Enough to decide whether a trail is for you:
               name, difficulty, region, the four numbers, featured views,
               and the opening line of the route. Full route, trail access
               and the CA89 route tip show as locked.

       kiosk   in store. The customer is ten feet from the rack, so friction
               costs a sale rather than protecting one. Everything shows,
               ending with a prompt to pick the deck up off the wall.

       full    unlocked — reserved for a code packed in every box, so the
               digital map becomes a reason to buy rather than a substitute.

     Override per surface with ?tier=kiosk, or set window.CA89_TIER before
     this script runs.
  ============================================================ */
  var CONTENT_TIER = (function () {
    var q = (location.search.match(/[?&]tier=(\w+)/) || [])[1];
    var t = q || window.CA89_TIER || 'public';
    return (t === 'kiosk' || t === 'full') ? t : 'public';
  })();

  var DECK_PRODUCT = {
    hike: { url: 'https://www.california89.com/products/lake-tahoe-hike-cards',
            name: 'Lake Tahoe Hike Cards' },
    bike: { url: 'https://www.california89.com/products/tahoe-bike-trail-cards',
            name: 'Tahoe Mountain Bike Trail Cards' }
  };

  // The hook: the first sentence of the route, and nothing more.
  function firstSentence(text) {
    if (!text) return '';
    var m = String(text).match(/^[\s\S]*?[.!?](?=\s|$)/);
    var out = (m ? m[0] : String(text)).trim();
    // A very short opener reads as a fragment; allow a second sentence.
    if (out.length < 60) {
      var rest = String(text).slice(out.length).match(/^\s*[\s\S]*?[.!?](?=\s|$)/);
      if (rest) out += ' ' + rest[0].trim();
    }
    return out;
  }

  /* ------------------------------------------------------------------
     TRAIL CARD POPUP
     Mirrors the printed card, in the printed order: stat block, the route
     narrative, trail access, the CA89 route tip, featured views, then the
     detail flags. The route tip is the part people actually pay for, so it
     gets the accent treatment rather than being buried in body copy.
  ------------------------------------------------------------------ */
  function buildCardPopup(loc) {
    var c    = loc.card;
    var col  = difficultyColor(c.difficulty, c.deck);
    var fnt  = "font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,Arial,sans-serif";
    var muted = 'rgba(255,255,255,0.55)';
    var label = 'font-size:9px;letter-spacing:0.14em;text-transform:uppercase;color:rgba(255,255,255,0.32);font-weight:600';

    function esc(t) {
      return String(t == null ? '' : t)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    function block(heading, body) {
      if (!body) return '';
      return '<div style="margin-top:12px">' +
             '<div style="' + label + '">' + heading + '</div>' +
             '<div style="font-size:12px;color:' + muted + ';line-height:1.55;margin-top:3px">' +
             esc(body) + '</div></div>';
    }

    var h = '<div style="' + fnt + ';max-height:360px;overflow-y:auto">';
    h += '<div style="padding:15px 17px 16px">';

    // deck badge, coloured by difficulty so it matches the card in your hand
    h += '<div style="display:flex;align-items:center;gap:7px;margin-bottom:9px;flex-wrap:wrap">';
    h += '<span style="background:' + col + ';color:#111;font-size:9px;font-weight:700;' +
         'padding:3px 9px;border-radius:99px;letter-spacing:0.1em;text-transform:uppercase">' +
         esc(c.deck) + ' card \u00b7 ' + esc(c.difficulty) + '</span>';
    if (c.partnerLogo) {
      h += '<span style="border:1px solid rgba(201,151,58,0.55);color:#C9973A;font-size:9px;' +
           'font-weight:600;padding:2px 8px;border-radius:99px;letter-spacing:0.06em">' +
           esc(c.partnerLogo) + '</span>';
    }
    h += '</div>';

    h += '<div style="font-size:16px;font-weight:700;color:#fff;line-height:1.2">' + esc(c.name) + '</div>';
    if (c.subtitle) {
      h += '<div style="font-size:10px;color:#C9973A;margin-top:3px;letter-spacing:0.03em">' +
           esc(c.subtitle) + '</div>';
    }
    h += '<div style="font-size:11px;color:rgba(255,255,255,0.4);margin-top:4px">' +
         esc(c.region) + ' \u00b7 ' + esc(c.town) + '</div>';

    // stat block, same four values as the card
    var stats = [
      ['Distance', c.distance], ['Gain', c.elevationGain],
      ['Time', c.time], ['Level', c.difficulty]
    ].filter(function (x) { return x[1]; });

    h += '<div style="display:grid;grid-template-columns:1fr 1fr;gap:9px 14px;margin-top:13px;' +
         'padding:11px 0;border-top:0.5px solid rgba(255,255,255,0.1);' +
         'border-bottom:0.5px solid rgba(255,255,255,0.1)">';
    stats.forEach(function (st) {
      h += '<div><div style="font-size:12.5px;font-weight:700;color:#fff;line-height:1.15">' +
           esc(st[1]) + '</div><div style="' + label + ';margin-top:2px">' + st[0] + '</div></div>';
    });
    h += '</div>';

    var open = (CONTENT_TIER !== 'public');

    // A locked section keeps its heading. An empty popup teaches nothing;
    // a visible gap tells you there is something you do not have.
    function locked(heading) {
      return '<div style="margin-top:12px;opacity:0.55">' +
             '<div style="' + label + '">' + heading +
             ' <span style="letter-spacing:0">\u00b7 on the card</span></div>' +
             '<div style="margin-top:5px;display:flex;flex-direction:column;gap:4px">' +
             '<span style="height:7px;border-radius:4px;background:rgba(255,255,255,0.09);width:100%"></span>' +
             '<span style="height:7px;border-radius:4px;background:rgba(255,255,255,0.09);width:92%"></span>' +
             '<span style="height:7px;border-radius:4px;background:rgba(255,255,255,0.09);width:64%"></span>' +
             '</div></div>';
    }

    if (open) {
      h += block('The Route', c.description);
      h += block('Trail Access', c.trailAccess);
    } else {
      // The opening line is the hook; the turn-by-turn is the product.
      h += block('The Route', firstSentence(c.description));
      h += locked('The Full Route');
      h += locked('Trail Access');
    }

    // The route tip is the part people pay for. Only the unlocked tier shows
    // it. The kiosk shows the full route and access but teases the tip, so the
    // deck on the wall beside it still has something the screen does not
    // (Ethan, 2026-10-24).
    if (c.routeTips && CONTENT_TIER === 'full') {
      h += '<div style="margin-top:12px;padding:10px 12px;border-left:2px solid ' + col + ';' +
           'background:rgba(255,255,255,0.04);border-radius:0 7px 7px 0">' +
           '<div style="' + label + '">CA89 Route Tip</div>' +
           '<div style="font-size:12px;color:rgba(255,255,255,0.78);line-height:1.55;margin-top:3px">' +
           esc(c.routeTips) + '</div></div>';
    } else if (c.routeTips) {
      h += '<div style="margin-top:12px;padding:10px 12px;border-left:2px solid ' + col + ';' +
           'background:rgba(255,255,255,0.04);border-radius:0 7px 7px 0;opacity:0.75">' +
           '<div style="' + label + '">CA89 Route Tip \u00b7 on the card</div>' +
           '<div style="font-size:11.5px;color:rgba(255,255,255,0.45);line-height:1.5;margin-top:4px;' +
           'font-style:italic">' + (CONTENT_TIER === 'kiosk'
             ? 'The local tip is on the card. The deck is right here on the wall.'
             : 'The local knowledge that is not on any trail sign.') + '</div></div>';
    }

    // Featured views stay public — they sell the trail rather than deliver it.
    h += block('Featured Views', c.featuredViews);

    // detail flags — hollow dot on the card means no
    // A hollow dot means no. Say it plainly rather than printing "Pets Allowed"
    // next to an empty dot and hoping the reader decodes it.
    function offLabel(t) {
      return /^pets allowed/i.test(t) ? 'No pets on this trail' : t + ': no';
    }
    var flags = [];
    if (c.parkingLabel) flags.push([c.parkingOnSite, c.parkingLabel]);
    if (c.petsLabel)    flags.push([c.petsAllowed, c.petsLabel]);
    if (flags.length) {
      h += '<div style="margin-top:13px;padding-top:11px;border-top:0.5px solid rgba(255,255,255,0.1)">';
      flags.forEach(function (f) {
        var on = f[0];
        h += '<div style="display:flex;align-items:flex-start;gap:7px;margin-bottom:4px">' +
             '<span style="width:9px;height:9px;border-radius:50%;flex-shrink:0;margin-top:3px;' +
             (on ? 'background:' + col + ';border:1px solid ' + col
                 : 'background:transparent;border:1px solid rgba(255,255,255,0.35)') + '"></span>' +
             '<span style="font-size:11px;line-height:1.35;color:' +
             (on ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.38)') + '">' +
             esc(on ? f[1] : offLabel(f[1])) + '</span></div>';
      });
      h += '</div>';
    }

    // The long-form guide, where one is published. Not on the kiosk: a link
    // out of a wall screen strands the next customer on a blog page.
    var gUrl = guideUrlFor(c);
    if (gUrl && CONTENT_TIER !== 'kiosk') {
      h += '<a href="' + gUrl + '" target="_blank" rel="noopener" ' +
           'style="display:block;margin-top:13px;font-size:11px;font-weight:600;color:#C9973A;' +
           'text-decoration:none;letter-spacing:0.04em">Read the full trail guide \u2192</a>';
    }

    var prod = DECK_PRODUCT[c.deck];
    if (prod && CONTENT_TIER !== 'full') {
      h += '<div style="margin-top:14px;padding-top:12px;border-top:0.5px solid rgba(255,255,255,0.1)">';
      if (CONTENT_TIER === 'kiosk') {
        h += '<div style="font-size:11.5px;color:rgba(255,255,255,0.6);line-height:1.5">' +
             'Take this one with you. <strong style="color:#C9973A">' + esc(prod.name) +
             '</strong> are right here on the wall.</div>';
      } else {
        h += '<div style="font-size:11.5px;color:rgba(255,255,255,0.55);line-height:1.5;margin-bottom:9px">' +
             'The full route, trailhead access and our insider tip are on the card.</div>' +
             '<a href="' + prod.url + '" target="_blank" rel="noopener noreferrer" ' +
             'style="display:block;text-align:center;background:' + col + ';color:#111;' +
             'padding:9px;border-radius:8px;font-size:11px;font-weight:700;text-decoration:none;' +
             'letter-spacing:0.06em;text-transform:uppercase">Get the ' + esc(c.deck) + ' cards \u2192</a>';
      }
      h += '</div>';
    }

    // Giving back, deck level: every box supports the deck's partner. Wording
    // is quoted from the product page via data/ca89-partners.js.
    var partner = (window.CA89_PARTNERS || {})[c.deck];
    if (partner && partner.give) {
      h += '<div style="margin-top:12px;padding:9px 11px;border:1px solid rgba(201,151,58,0.3);' +
           'border-radius:8px;font-size:11px;line-height:1.45;color:rgba(255,255,255,0.65)">' +
           '<div style="' + label + ';color:#C9973A;margin-bottom:2px">Giving back</div>' +
           esc(partner.give) + '.</div>';
    }

    if (c.photoCredit) {
      h += '<div style="font-size:9px;color:rgba(255,255,255,0.25);margin-top:11px">Photo: ' +
           esc(c.photoCredit) + '</div>';
    }

    h += '</div></div>';
    return h;
  }

  function buildPopup(loc) {
    if (loc.type === 'card' && loc.card) return buildCardPopup(loc);

    var cfg     = TYPE_CONFIG[loc.type];
    var isStore = (loc.type === 'store');
    var isFav   = (loc.type === 'favorite');
    var fnt     = 'font-family:-apple-system,BlinkMacSystemFont,\'Segoe UI\',Helvetica,Arial,sans-serif';

    var h = '<div style="' + fnt + '">';

    // Stats come straight off the place record, so the popup and the printed
    // rack card always show the same numbers.
    // Printed-card field order. The popup shows the same numbers, in the same
    // order, as the physical card — so the screen and the rack never disagree.
    var NOTE_ORDER = [
      ['distance', 'Distance'], ['gain', 'Gain'], ['time', 'Time'],
      ['level', 'Level'], ['area', 'Area'], ['elevation', 'Elevation'],
      ['height', 'Height'], ['flow', 'Flow'], ['population', 'Population'],
      ['shoreline', 'Shoreline'], ['maxDepth', 'Max depth']
    ];

    function statStrip(notes) {
      if (!notes) return '';
      var cells = NOTE_ORDER
        .filter(function (pair) { return notes[pair[0]]; })
        .slice(0, 4);
      if (!cells.length) return '';

      var out = '<div style="display:flex;gap:14px;margin:10px 0 2px;flex-wrap:wrap">';
      cells.forEach(function (pair) {
        out += '<div>' +
               '<div style="font-size:13px;font-weight:700;color:#fff;line-height:1.1">' + notes[pair[0]] + '</div>' +
               '<div style="font-size:9px;letter-spacing:0.1em;text-transform:uppercase;' +
               'color:rgba(255,255,255,0.35);margin-top:2px">' + pair[1] + '</div>' +
               '</div>';
      });
      return out + '</div>';
    }

    if (isFav) {
      h += '<div style="border-top:2px solid #C9973A;border-radius:12px;overflow:hidden">';
      h += '<div style="padding:16px 18px">';
      h += '<span style="background:#C9973A;color:#111;font-size:9px;font-weight:700;padding:2px 8px;border-radius:99px;letter-spacing:0.1em">CA89 PICK</span>';
      h += '<div style="font-size:15px;font-weight:700;color:#fff;margin:8px 0 4px">' + loc.name + '</div>';
      h += '<div style="font-size:12px;color:rgba(255,255,255,0.55);line-height:1.6">' + loc.desc + '</div>';
      h += statStrip(loc.notes);
      h += '</div></div>';
    } else {
      h += '<div style="padding:16px 18px 18px">';
      // Badge
      h += '<div style="margin-bottom:10px">';
      h += '<span style="display:inline-block;background:' + cfg.color + ';color:' + (isStore ? '#fff' : '#111') + ';font-size:10px;font-weight:600;padding:3px 10px;border-radius:99px;letter-spacing:0.08em;text-transform:uppercase">' + cfg.label + '</span>';
      h += '</div>';
      // Name
      h += '<div style="font-size:15px;font-weight:700;color:#fff;margin-bottom:6px;line-height:1.2">' + loc.name + '</div>';
      // Desc
      h += '<div style="font-size:12px;color:rgba(255,255,255,0.55);line-height:1.6;margin-bottom:' + (isStore ? '12px' : '0') + '">' + loc.desc + '</div>';
      if (loc.fact) {
        h += '<div style="font-size:11px;color:#C9973A;line-height:1.5;margin-top:6px;letter-spacing:0.02em">' + loc.fact + '</div>';
      }
      h += statStrip(loc.notes);
      // Store actions
      if (isStore) {
        h += '<div style="display:flex;gap:8px;margin-top:4px">';
        h += '<a href="' + (loc.shopUrl || 'https://www.california89.com') + '" target="_blank" rel="noopener noreferrer" ' +
             'style="flex:1;background:#1D9E75;color:#fff;text-align:center;padding:8px;border-radius:8px;font-size:11px;font-weight:600;text-decoration:none;letter-spacing:0.05em">SHOP NOW →</a>';
        if (loc.directionsUrl) {
          h += '<a href="' + loc.directionsUrl + '" target="_blank" rel="noopener noreferrer" ' +
               'style="flex:1;border:1px solid rgba(201,151,58,0.5);color:#C9973A;text-align:center;padding:8px;border-radius:8px;font-size:11px;font-weight:600;text-decoration:none;letter-spacing:0.05em">DIRECTIONS →</a>';
        }
        h += '</div>';
      }
      h += '</div>';
    }

    h += '</div>';
    return h;
  }

  /* ============================================================
     CREATE MARKERS
  ============================================================ */
  var markerList = [];
  var allLatLngs = LOCATIONS.map(function (loc) { return [loc.lat, loc.lon]; });
  var allBounds  = L.latLngBounds(allLatLngs);

  /* Trail cards cluster; stores and landmarks stay put so the map always
     shows where you can actually shop and the headline destinations. */
  var clusterGroup = L.markerClusterGroup({
    maxClusterRadius: 45,
    spiderfyDistanceMultiplier: 1.6,
    // Tapping a number always fans its trails out where they are. Zooming in
    // on some clusters and fanning out others felt inconsistent (Ethan,
    // 2026-10-23); the region callouts already handle "take me there".
    zoomToBoundsOnClick: false,
    spiderfyOnEveryZoom: true,
    showCoverageOnHover: false,
    iconCreateFunction: function (cluster) {
      var n = cluster.getChildCount();
      var size = n < 10 ? 'sm' : (n < 30 ? 'md' : 'lg');
      return L.divIcon({
        html: '<div class="ca89-cluster ca89-cluster-' + size + '">' + n + '</div>',
        className: '',
        iconSize: null
      });
    }
  });
  map.addLayer(clusterGroup);

  var NARROW       = window.matchMedia('(max-width: 768px)').matches;
  var POPUP_MAX_W  = NARROW ? Math.min(340, window.innerWidth - 40) : 340;
  var POPUP_PAD_TL = NARROW ? [12, 64]  : [235, 24];
  var POPUP_PAD_BR = NARROW ? [12, 112] : [24, 24];

  LOCATIONS.forEach(function (loc) {
    var icon = loc.leader
      ? createLeaderIcon(loc.type, loc.leader.label, loc.leader.dir)
      : createIcon(loc);

    var popupClass = 'ca89-popup' + (loc.type === 'store' ? ' ca89-popup-store' : '');
    var marker = L.marker([loc.lat, loc.lon], { icon: icon })
      .bindPopup(buildPopup(loc), {
        maxWidth:  POPUP_MAX_W,
        className: popupClass,
        // Keep the popup clear of the controls. Desktop: the legend sidebar on
        // the left. Phone: the zoom and Fit All Pins buttons along the top and
        // the filter pills along the bottom, which otherwise cover the close X.
        autoPanPaddingTopLeft:     POPUP_PAD_TL,
        autoPanPaddingBottomRight: POPUP_PAD_BR
      })
      .bindTooltip(loc.name, {
        permanent:  false,
        direction:  'top',
        offset:     [0, -4],
        className:  'ca89-tooltip'
      });

    if (loc.type === 'card') { clusterGroup.addLayer(marker); }
    else                     { marker.addTo(map); }

    /* Fly IN to the pin on click, never out. The popup opens immediately
       either way. Flying out to a fixed zoom re-clusters the trail you just
       tapped and closes its card, which is what used to happen when opening
       a pin from a spread-out cluster at street level. Zooming in can only
       un-cluster, so the tapped marker always stays on the map. */
    var FLY_ZOOM = 13;
    marker.on('click', function () {
      // Trail pins only show at street level (the overview shows region
      // callouts), and flying would fold a fanned-out cluster back up and
      // close the card. So trail cards open in place.
      if (loc.type === 'card') return;
      if (map.getZoom() < FLY_ZOOM) {
        map.flyTo([loc.lat, loc.lon], FLY_ZOOM, { duration: 1.2 });
      }
    });

    /* Hover scale on the wrapper div */
    marker.on('mouseover', function () {
      if (marker._icon && marker._icon.firstChild)
        marker._icon.firstChild.style.transform = 'scale(1.22)';
    });
    marker.on('mouseout', function () {
      if (marker._icon && marker._icon.firstChild)
        marker._icon.firstChild.style.transform = 'scale(1)';
    });

    if (loc.card) marker.__card = loc.card;
    markerList.push({
      loc: loc, waypoint: !!loc.waypoint,
      type: loc.type, deck: loc.deck || null,
      level: String((loc.notes && loc.notes.level) || '').toLowerCase() || null,
      marker: marker, visible: true
    });
  });

  /* ============================================================
     FILTER — deck/kind AND difficulty, combined
     Clustered markers cannot be hidden with opacity: the cluster would still
     count them and show a wrong number. They have to leave the layer group.
  ============================================================ */
  // Layers on the map. Hike, Bike and Stores start on; "More along 89"
  // (iconic spots and favorites) starts off so the opening view stays clean.
  var layersOn  = { hike: false, bike: false, store: true, more: 'waypoints' };   // The Road
  var activeDiff = 'all';

  function matches(item) {
    if (item.type === 'card') {
      if (!layersOn[item.deck]) return false;
      // Difficulty only exists on trail cards and only filters them.
      return activeDiff === 'all' || item.level === activeDiff;
    }
    if (item.type === 'store') return layersOn.store;
    // Favorites (restaurants and the like) wait for the Eats & Drinks tab.
    if (item.type === 'favorite') return false;
    // Iconic landmarks: The Road shows only the waypoints spread along the
    // highway; the Landmarks tab shows every stop from the poster.
    if (layersOn.more === 'all') return true;
    return layersOn.more === 'waypoints' && item.waypoint;
  }

  function applyFilter() {
    var shown = 0;

    markerList.forEach(function (item) {
      var show = matches(item);
      item.visible = show;
      if (show) shown++;

      if (item.type === 'card') {
        var inGroup = clusterGroup.hasLayer(item.marker);
        if (show && !inGroup)      clusterGroup.addLayer(item.marker);
        else if (!show && inGroup) clusterGroup.removeLayer(item.marker);
      } else {
        var onMap = map.hasLayer(item.marker);
        if (show && !onMap)      item.marker.addTo(map);
        else if (!show && onMap) map.removeLayer(item.marker);
      }
    });

    var diffSec = document.getElementById('diff-section');
    if (diffSec) diffSec.classList.toggle('is-hidden', !(layersOn.hike || layersOn.bike));

    var el = document.getElementById('filter-count');
    if (el) {
      el.textContent = shown === markerList.length
        ? shown + ' locations'
        : shown + ' of ' + markerList.length + ' locations';
    }
    updateRegions();
  }

  /* ============================================================
     EXPLORER — tabs + list (2026-11-03)
     The first look is "The Road": Highway 89 and the landmarks from our
     road map poster. Hike, Bike and Stores are tabs, each with its own list
     and its own map view. Tab position is a layout: left rail (desktop),
     bottom dock (phones and the kiosk) or top bar. ?tabs=left|top|bottom
     forces one; ?play shows a switcher for trying them.
  ============================================================ */
  var explorerWrap = document.querySelector('.ca89-map-wrap');
  var tabsEl  = document.getElementById('ca89-tabs');
  var panelEl = document.getElementById('ca89-panel');
  var listEl  = document.getElementById('ca89-list');
  var allDiffBtns = document.querySelectorAll('.diff-btn');
  var tabBtns = document.querySelectorAll('.ca89-tab');

  var TAB_LAYOUT = (location.search.match(/[?&]tabs=(left|top|bottom)/) || [])[1] ||
                   window.CA89_TABS || (IS_KIOSK ? 'bottom' : 'auto');
  function isNarrow() { return window.matchMedia('(max-width: 768px)').matches; }
  function applyLayout() {
    var l = TAB_LAYOUT === 'auto' ? 'left' : TAB_LAYOUT;
    if (isNarrow()) l = 'bottom';
    explorerWrap.setAttribute('data-tabs', l);
  }
  applyLayout();

  var DECK_COUNT = { hike: 0, bike: 0 };
  CARDS.forEach(function (c) { DECK_COUNT[c.deck] = (DECK_COUNT[c.deck] || 0) + 1; });
  function siteUrl(path) { return SITE_ORIGIN + path; }

  var TABS = {
    road: {
      eyebrow: 'Highway 89', title: 'The Road',
      sub: 'Mt. Shasta to Monitor Pass. Open Landmarks for every stop on our road map.',
      cta: { text: 'Get the Road Map poster', href: siteUrl('/products/ca89-road-map-poster') },
      layers: { store: true, more: 'waypoints' }, frame: 'route', kind: 'places'
    },
    landmarks: {
      eyebrow: 'From our road map', title: 'Landmarks',
      sub: 'Every stop on the Highway 89 Road Map poster, north to south.',
      cta: { text: 'Get the Road Map poster', href: siteUrl('/products/ca89-road-map-poster') },
      layers: { store: true, more: 'all' }, frame: 'landmarks', kind: 'places'
    },
    hike: {
      eyebrow: 'Lake Tahoe Hike Cards', title: DECK_COUNT.hike + ' hikes',
      sub: 'Every trail in the deck, by region. Tap one to see it on the map.',
      cta: { text: 'Get the hike cards', href: DECK_PRODUCT.hike.url, kiosk: 'The deck is right here on the wall' },
      layers: { hike: true, store: true }, frame: 'home', deck: 'hike'
    },
    bike: {
      eyebrow: 'Tahoe Mountain Bike Trail Cards', title: DECK_COUNT.bike + ' rides',
      sub: 'Every trail in the deck, by region. Tap one to see it on the map.',
      cta: { text: 'Get the bike cards', href: DECK_PRODUCT.bike.url, kiosk: 'The deck is right here on the wall' },
      layers: { bike: true, store: true }, frame: 'home', deck: 'bike'
    },
    stores: {
      eyebrow: 'Visit us', title: 'Our stores',
      sub: 'Three shops on Highway 89: two in Truckee, one in Tahoe City.',
      cta: null, layers: { store: true }, frame: 'stores'
    }
  };

  function escHtml(t) {
    return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // The very first frame can run before TABS is defined (the map frames as
  // soon as it has a size), so fall back to The Road's view.
  function tabFrame(key) {
    return (typeof TABS !== 'undefined' && TABS && TABS[key]) ? TABS[key].frame : 'route';
  }
  function tabBounds(key) {
    var f = tabFrame(key || 'road');
    if (f === 'route')  return routeBounds || allBounds;
    if (f === 'stores') return STORE_BOUNDS;
    if (f === 'landmarks') return LANDMARK_BOUNDS || HOME_BOUNDS;
    return HOME_BOUNDS;
  }
  function frameTab(animate) {
    var b = tabBounds(activeTab);
    if (!b) return;
    var opts = framePadding();
    if (tabFrame(activeTab) === 'stores') opts.maxZoom = 12;
    if (animate) map.flyToBounds(b, Object.assign({ duration: 0.9 }, opts));
    else         map.fitBounds(b, Object.assign({ animate: false }, opts));
  }

  function renderHead() {
    var t = TABS[activeTab];
    document.getElementById('ca89-panel-eyebrow').textContent = t.eyebrow;
    document.getElementById('ca89-panel-title').textContent =
      activeTab === 'landmarks' ? (itemsForTab().length + ' landmarks') : t.title;
    document.getElementById('ca89-panel-sub').textContent = t.sub;
    var cta = document.getElementById('ca89-panel-cta');
    if (!t.cta) { cta.innerHTML = ''; return; }
    if (IS_KIOSK) {
      cta.innerHTML = t.cta.kiosk ? '<span>' + escHtml(t.cta.kiosk) + '</span>' : '';
    } else {
      cta.innerHTML = '<a href="' + t.cta.href + '">' + escHtml(t.cta.text) + ' →</a>';
    }
  }

  function itemsForTab() {
    return markerList.filter(function (i) {
      if (!i.visible) return false;
      if (activeTab === 'road' || activeTab === 'landmarks') return i.type === 'iconic';
      if (activeTab === 'stores') return i.type === 'store';
      return i.type === 'card' && i.deck === activeTab;
    });
  }

  function itemButton(i) {
    var loc = i.loc, idx = markerList.indexOf(i), dot, meta;
    if (i.type === 'card') {
      var c = loc.card;
      dot  = difficultyColor(c.difficulty, c.deck);
      meta = [c.difficulty, c.distance, c.elevationGain && (c.elevationGain + ' gain')].filter(Boolean).join(' · ');
    } else {
      dot  = i.type === 'store' ? '#C9973A' : '#2B2620';
      meta = loc.fact || loc.desc || '';
    }
    return '<li><button class="ca89-item" type="button" data-idx="' + idx + '">' +
           '<span class="ca89-item-dot" style="background:' + dot + ';' +
             (i.type === 'iconic' ? 'border:2px solid #E8E0D0;' : '') + '"></span>' +
           '<span><span class="ca89-item-name">' + escHtml(loc.name) + '</span>' +
           (meta ? '<span class="ca89-item-meta">' + escHtml(meta) + '</span>' : '') +
           '</span></button></li>';
  }

  function renderList() {
    var items = itemsForTab(), html = '';
    var t = TABS[activeTab];
    if (t.deck) {
      // Group by the region printed on the cards, north to south.
      var groups = {};
      items.forEach(function (i) { var r = i.loc.card.region; (groups[r] = groups[r] || []).push(i); });
      Object.keys(groups).map(function (r) {
        var g = groups[r], lat = 0;
        g.forEach(function (i) { lat += i.loc.lat; });
        return { name: r, items: g, lat: lat / g.length };
      }).sort(function (a, b) { return b.lat - a.lat; }).forEach(function (g) {
        html += '<li class="ca89-list-group"><span>' + escHtml(g.name) + '</span><span>' + g.items.length + '</span></li>';
        g.items.sort(function (a, b) { return a.loc.name.localeCompare(b.loc.name); })
               .forEach(function (i) { html += itemButton(i); });
      });
    } else {
      // Along the road, north to south, the way the poster reads.
      items.sort(function (a, b) { return b.loc.lat - a.loc.lat; })
           .forEach(function (i) { html += itemButton(i); });
    }
    listEl.innerHTML = html;
    listEl.scrollTop = 0;
    var el = document.getElementById('filter-count');
    if (el) el.textContent = t.deck ? (items.length + ' trails') : (items.length + (activeTab === 'stores' ? ' stores' : ' places'));
  }

  function setSheet(open) { panelEl.classList.toggle('is-open', !!open); setTimeout(fitLabels, 400); }

  // Fly to an item from the list and open its card. Trails sit in the
  // cluster group, which zoomToShowLayer can spread out if needed.
  function focusItem(item) {
    var ll = item.marker.getLatLng(), done = false;
    function open() {
      if (done) return; done = true;
      if (item.type === 'card') {
        syncRegionMode();
        clusterGroup.zoomToShowLayer(item.marker, function () { item.marker.openPopup(); });
      } else {
        item.marker.openPopup();
      }
    }
    if (isNarrow()) setSheet(false);
    map.closePopup();
    map.once('moveend', open);
    setTimeout(open, 1400);   // if the map was already there, moveend may not fire
    map.flyTo(ll, Math.max(map.getZoom(), item.type === 'card' ? 14 : 12), { duration: 0.9 });
  }

  function selectTab(key, animate) {
    if (!TABS[key]) return;
    activeTab = key;
    var L_ = TABS[key].layers;
    layersOn = { hike: !!L_.hike, bike: !!L_.bike, store: !!L_.store, more: L_.more || false };
    activeDiff = 'all';
    allDiffBtns.forEach(function (b) { b.classList.toggle('active', b.getAttribute('data-diff') === 'all'); });
    tabBtns.forEach(function (b) {
      var on = b.getAttribute('data-tab') === key;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    map.closePopup();
    applyFilter();
    renderHead();
    renderList();
    frameTab(animate);
  }

  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () { selectTab(btn.getAttribute('data-tab'), true); });
  });

  allDiffBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      activeDiff = btn.getAttribute('data-diff');
      allDiffBtns.forEach(function (b) {
        b.classList.toggle('active', b.getAttribute('data-diff') === activeDiff);
      });
      applyFilter();
      renderList();
    });
  });

  listEl.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-idx]');
    if (b) focusItem(markerList[+b.getAttribute('data-idx')]);
  });

  // Phone sheet: tapping the header opens and closes the list.
  document.getElementById('ca89-panel-head').addEventListener('click', function (e) {
    if (!isNarrow() || (e.target.closest && e.target.closest('a'))) return;
    setSheet(!panelEl.classList.contains('is-open'));
  });

  // The tabs and list are not part of the map: clicks and scrolls stay there.
  L.DomEvent.disableClickPropagation(tabsEl);
  L.DomEvent.disableClickPropagation(panelEl);
  L.DomEvent.disableScrollPropagation(panelEl);

  // Popups pan clear of the tabs and the list in whatever layout is showing.
  map.on('popupopen', function (e) {
    var o = obstacles(), b = o.box;
    e.popup.options.autoPanPaddingTopLeft     = L.point(o.left - b.left + 8, o.top - b.top + 8);
    e.popup.options.autoPanPaddingBottomRight = L.point(b.right - o.right + 8, b.bottom - o.bottom + 8);
    if (e.popup._adjustPan) e.popup._adjustPan();
  });

  // ?play: a switcher above the map for trying the three tab layouts.
  var playEl = document.getElementById('ca89-play');
  if (playEl && /[?&]play\b/.test(location.search)) {
    playEl.hidden = false;
    var playBtns = playEl.querySelectorAll('[data-layout]');
    function markPlay() {
      var cur = explorerWrap.getAttribute('data-tabs');
      playBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-layout') === cur); });
    }
    playBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        TAB_LAYOUT = b.getAttribute('data-layout');
        applyLayout(); markPlay();
        setTimeout(function () { frameTab(true); fitLabels(); }, 60);
      });
    });
    markPlay();
  }

  window.addEventListener('resize', function () { applyLayout(); });

  /* ============================================================
     REGION CALLOUTS — the zoomed-out view
     54 of 60 trails sit in about 5% of the highway, so at overview zoom
     individual pins are a pile. Below CALLOUT_ZOOM the trail pins step aside
     and each region printed on the cards gets one label, set out in open
     space with a leader line to where its trails are. Tap a label to drop
     into that region. Counts follow the Hike / Bike / difficulty filters.
     Offsets are screen pixels from the region's centre: [x, y], y down.
  ============================================================ */
  var CALLOUT_ZOOM = 11;
  // Further out than this (the whole-highway view) the seven regions are a
  // few pixels apart, so they merge into one "Truckee & Tahoe" label.
  var MERGE_ZOOM = 9;
  var builtMerged = null;           // which label set regionLayer holds
  var REGION_OFFSETS = {
    'Soda Springs': [-120,  70],
    'Near Truckee': [-110, -95],
    'Truckee':      [  70, -110],
    'North Lake':   [ 165, -12],
    'East Shore':   [ 140,  55],
    'West Shore':   [-160,  25],
    'South Lake':   [-140,  80]
  };
  var regionLayer = L.layerGroup();

  function regionIcon(name, count, dx, dy) {
    var k = window.matchMedia('(max-width: 768px)').matches ? 0.62 : 1;
    dx = Math.round(dx * k); dy = Math.round(dy * k);
    var light = (THEME === 'light');
    var line = light ? 'rgba(43,38,32,0.6)' : 'rgba(255,255,255,0.6)';
    // Labels left of the dot end at the line; labels right of it start there.
    var tx = dx < 0 ? '-100%' : '0';
    var html =
      '<div class="ca89-region">' +
        '<svg width="1" height="1"><line x1="0" y1="0" x2="' + dx + '" y2="' + dy + '" ' +
          'stroke="' + line + '" stroke-width="1.25"/></svg>' +
        '<span class="ca89-region-dot"></span>' +
        '<span class="ca89-region-label" data-dx="' + dx + '" data-dy="' + dy + '" ' +
          'style="left:' + dx + 'px;top:' + dy + 'px;--tx:' + tx + '">' +
          name + '<b>' + count + '</b></span>' +
      '</div>';
    return L.divIcon({ className: '', html: html, iconSize: [0, 0], iconAnchor: [0, 0] });
  }

  function updateRegions() {
    regionLayer.clearLayers();
    var merged = map.getZoom() < MERGE_ZOOM;
    builtMerged = merged;
    var groups = {};
    markerList.forEach(function (item) {
      if (item.type !== 'card' || !item.visible) return;
      var c = item.marker.__card;
      var key = merged ? 'Truckee & Tahoe' : c.region;
      (groups[key] = groups[key] || []).push(c);
    });
    Object.keys(groups).forEach(function (name) {
      var cards = groups[name];
      var lat = 0, lon = 0;
      cards.forEach(function (c) { lat += c.lat; lon += c.lon; });
      lat /= cards.length; lon /= cards.length;
      var off = merged ? [150, -70] : (REGION_OFFSETS[name] || [120, -60]);
      var m = L.marker([lat, lon], {
        icon: regionIcon(name, cards.length, off[0], off[1]),
        keyboard: false, zIndexOffset: 1000
      });
      m.on('click', function () {
        if (merged) {
          map.flyToBounds(HOME_BOUNDS, Object.assign({ duration: 1 }, homePadding()));
          return;
        }
        var b = L.latLngBounds(cards.map(function (c) { return [c.lat, c.lon]; }));
        var z = Math.max(CALLOUT_ZOOM, Math.min(13, map.getBoundsZoom(b.pad(0.15))));
        map.flyTo(b.getCenter(), z, { duration: 0.9 });
      });
      regionLayer.addLayer(m);
    });
    syncRegionMode();
  }

  /* Keep every label inside the visible map, clear of the controls. Each
     label starts at its designed offset; if that runs off an edge (a phone,
     or a region near the side of the view), it slides back in and its leader
     line follows. Re-run whenever the map moves. */
  function fitLabels() {
    if (!map.hasLayer(regionLayer)) return;
    var lim = obstacles();
    lim.top = Math.max(lim.top, lim.box.top + 56);     // zoom + reset buttons
    regionLayer.eachLayer(function (m) {
      var el = m.getElement && m.getElement();
      if (!el) return;
      var lab = el.querySelector('.ca89-region-label');
      var line = el.querySelector('line');
      var dx = +lab.getAttribute('data-dx'), dy = +lab.getAttribute('data-dy');
      lab.style.left = dx + 'px'; lab.style.top = dy + 'px';
      var r = lab.getBoundingClientRect(), sx = 0, sy = 0;
      if (r.left < lim.left)        sx = lim.left - r.left;
      else if (r.right > lim.right) sx = lim.right - r.right;
      if (r.top < lim.top)            sy = lim.top - r.top;
      else if (r.bottom > lim.bottom) sy = lim.bottom - r.bottom;
      lab.style.left = (dx + sx) + 'px'; lab.style.top = (dy + sy) + 'px';
      line.setAttribute('x2', dx + sx); line.setAttribute('y2', dy + sy);
    });
  }
  map.on('moveend', fitLabels);
  window.addEventListener('resize', fitLabels);

  // Overview zoom shows callouts; closer in shows the real pins.
  function syncRegionMode() {
    var z = map.getZoom();
    var overview = z < CALLOUT_ZOOM;
    // Crossing MERGE_ZOOM swaps the label set; updateRegions() calls back here
    // once rebuilt, and builtMerged then matches, so this cannot loop.
    if (overview && builtMerged !== (z < MERGE_ZOOM)) { updateRegions(); return; }
    if (overview) {
      if (map.hasLayer(clusterGroup)) map.removeLayer(clusterGroup);
      if (!map.hasLayer(regionLayer)) regionLayer.addTo(map);
      fitLabels();
    } else {
      if (map.hasLayer(regionLayer)) map.removeLayer(regionLayer);
      if (!map.hasLayer(clusterGroup)) map.addLayer(clusterGroup);
    }
  }
  map.on('zoomend', syncRegionMode);

  selectTab('road', false);   // the first look

  document.querySelectorAll('.basemap-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      setBasemap(btn.getAttribute('data-base'));
    });
  });


  /* ============================================================
     FIT ALL PINS CONTROL — topright, gold border
  ============================================================ */
  var FitControl = L.Control.extend({
    options: { position: 'topright' },
    onAdd: function () {
      var btn = L.DomUtil.create('button', 'ca89-fit-btn');
      btn.type = 'button';
      btn.textContent = 'Reset view';
      L.DomEvent.disableClickPropagation(btn);
      L.DomEvent.on(btn, 'click', function () { map.closePopup(); frameTab(true); });
      return btn;
    }
  });

  new FitControl().addTo(map);

  /* ============================================================
     GEOLOCATION — pulsing "you are here" dot
  ============================================================ */
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function (pos) {
      var latlng = [pos.coords.latitude, pos.coords.longitude];
      // Pulsing outer ring
      L.circleMarker(latlng, {
        radius: 16, fillColor: '#4A90E2', fillOpacity: 0.18,
        color: '#4A90E2', weight: 1, interactive: false
      }).addTo(map);
      // Solid inner dot
      L.circleMarker(latlng, {
        radius: 7, fillColor: '#4A90E2', fillOpacity: 1,
        color: '#ffffff', weight: 2
      }).addTo(map).bindTooltip('You are here', {
        permanent: false, direction: 'top', className: 'ca89-tooltip'
      });
    }, null, { enableHighAccuracy: false, timeout: 8000 });
  }

} // end ca89MapInit

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ca89MapInit);
} else {
  ca89MapInit();
}
